import { VideoRecorder } from "@untitled-ui/icons-react";

import MeetWrapper from "./user/components/MeetWrapper";

export default {
  name: "meet",
  priority: 11,
  icon: VideoRecorder,
  wrapper: {
    user: MeetWrapper,
  },
  menu: (): { admin: [] } => ({
    admin: [],
  }),
} satisfies ModuleData;
